import { getWhiteLabelConfig } from "~/utils/white-label";

export const Logo = () => {
  const cfg = getWhiteLabelConfig();

  if (!cfg.logo_url) return null;

  return (
    <img
      src={cfg.logo_url}
      alt={cfg.company_name}
      style={{
        width: "3.243rem",
        height: "2.75rem",
        objectFit: "contain",
      }}
    />
  );
};
